export interface IndexingStatus {
  processId: string;
  clientId: string;
  status: 'QUEUED' | 'RUNNING' | 'COMPLETED' | 'FAILED' | 'PARTIALLY_COMPLETED';
  startTime: string;
  endTime?: string;
  processedDocuments: number;
  failedDocuments: number;
  totalDocuments: number;
  currentPhase: string;
  errorMessage?: string;
  progress: number;
}

export interface IndexingProgress {
  id: string;
  processedDocuments: number;
  failedDocuments: number;
  phase: string;
  message: string;
  createdAt: string;
}

export interface IndexingHistoryResponse {
  content: IndexingStatus[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export interface IndexingProgressResponse {
  content: IndexingProgress[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}